

// useActivityTracker.js


import { useEffect } from 'react';
import { isGuestUser } from './authHelpers';
import Parse from '../../parseConfig';


const useActivityTracker = () => {

    const user = Parse.User.current();
    const userId = user?.id;

    useEffect(() => {

        if (!user || !isGuestUser(user)) return;

        const updateLastActive = () => {

            const now = new Date().toISOString();
            localStorage.setItem('guestLastActiveAt', now);

            //console.log(`[ActivityTracker] Updated guestLastActiveAt to ${now}`);
        };

        const activityEvents = ['keydown', 'scroll', 'click'];

        activityEvents.forEach((event) => {
            window.addEventListener(event, updateLastActive);
            //console.log(`[ActivityTracker] Listening for ${event}`);
        });

        updateLastActive(); // On load

        return () => {
            activityEvents.forEach((event) => {
                window.removeEventListener(event, updateLastActive);
            });
        };
    }, [user, userId]);

};

export default useActivityTracker;




